/** Read the path segment immediately after `marker` from the browser URL (web only). */
export function readPathSegmentAfter(marker) {
  if (typeof window === 'undefined' || !marker) return '';
  const parts = String(window.location.pathname || '').split('/').filter(Boolean);
  const idx = parts.findIndex((p) => p === marker);
  if (idx < 0 || !parts[idx + 1]) return '';
  try {
    return decodeURIComponent(parts[idx + 1]);
  } catch {
    return parts[idx + 1];
  }
}
